import Vue from 'vue'

// Lib imports
import axios from 'axios'


var instance = axios.create({ timeout: 1000 * 12 });
instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// instance.defaults.baseURL = baseURLModel[process.env.NODE_ENV] || baseURLModel['development'];
instance.defaults.baseURL = process.env.VUE_APP_BASE_API;


const errorHandle = (status, other) => {
    switch (status) {
        case 401:
            break;
        case 403:
            break;
        case 404:
            break;
        default:
            console.log(other);
    }
}


instance.interceptors.request.use(
    config => {
        return config;
    },
    error => {
        return Promise.error(error);
    });


instance.interceptors.response.use(
    res => res.status === 200 ? Promise.resolve(res) : Promise.reject(res),
    error => {
        const { response } = error;
        if (response) {
            errorHandle(response.status, response.data.message);
            return Promise.reject(response);
        } else {
            // network abort
            // store.commit('changeNetwork', false);
        }
    });


Vue.prototype.$http = instance